import React from "react";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import EmailIcon from "@material-ui/icons/Email";
import GithubIcon from "@material-ui/icons/GitHub";
import "../styles/Footer.css";

function Footer() {
  return (
    <div className="footer">
      <div className="prompt">

        <a href='https://www.linkedin.com/in/inigo-malluguiza-castro/'><LinkedInIcon /></a>
        <a href='https://github.com/Inigo-Javier'><GithubIcon /></a>
        <a href='mailto:imalluguizacastro@gmail.com'> <EmailIcon /></a>

      </div>
      <p>Iñigo Malluguiza Castro </p>
      <p>  &copy; Full Stack Developer, 2022 </p>
    </div>
  );
}

export default Footer;
